import React from 'react';
import { Button, ButtonGroup } from 'react-bootstrap';
import { useMultiStationContext } from '@graphs/MultiStation/MultiStationContext';

const MultiStationButtonGroup = () => {
  const {
    showInvalid,
    setShowInvalid,
    showLegend,
    setShowLegend,
    syncGraphs,
    setSyncGraphs,
    showReticle,
    setShowReticle,
  }: any = useMultiStationContext();

  const FEATURE_ENABLED = {
    LEGEND_TOGGLE: true,
    SYNC_GRAPHS: false,
    SHOW_INVALID: true,
  };

  const handleInvalidToggle = () => {
    setShowInvalid(!showInvalid);
  };

  const handleLegendToggle = () => {
    setShowLegend(!showLegend);
  };

  const handleSyncToggle = () => {
    setSyncGraphs(!syncGraphs);
  };

  const handleShowReticle = () => {
    setShowReticle(!showReticle);
  };

  return (
    <ButtonGroup toggle>
      {FEATURE_ENABLED.SHOW_INVALID ? (
        <Button variant={showInvalid ? 'primary' : 'secondary'} onClick={handleInvalidToggle}>
          {showInvalid ? 'Hide Invalid' : 'Show Invalid'}
        </Button>
      ) : null}
      {FEATURE_ENABLED.LEGEND_TOGGLE ? (
        <Button variant={showLegend ? 'primary' : 'secondary'} onClick={handleLegendToggle}>
          {showLegend ? 'Hide Legends' : 'Show Legends'}
        </Button>
      ) : null}
      {FEATURE_ENABLED.SYNC_GRAPHS ? (
        <Button variant={syncGraphs ? 'primary' : 'secondary'} onClick={handleSyncToggle}>
          {syncGraphs ? 'Desync Graphs' : 'Sync Graphs'}
        </Button>
      ) : null}
      <Button variant={showReticle ? 'primary' : 'secondary'} onClick={handleShowReticle}>
        {showReticle ? 'Hide Reticle' : 'Show Reticle'}
      </Button>
    </ButtonGroup>
  );
};

export default MultiStationButtonGroup;
